// paypalSDKLoader.js
let paypalPromise = null;
let buttonRendered = false; // Track if the button has been rendered

export const loadPayPalSDK = () => {
    if (paypalPromise) {
        return paypalPromise; // Return existing promise if already loading
    }

    paypalPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = "https://www.paypalobjects.com/donate/sdk/donate-sdk.js";
        script.async = true;
        script.charset = "UTF-8";

        script.onload = () => {
            if (window.PayPal) {
                resolve(window.PayPal); // Resolve with the PayPal object
            } else {
                reject(new Error("PayPal SDK failed to load."));
            }
        };

        script.onerror = () => {
            reject(new Error("Failed to load PayPal SDK."));
        };

        document.body.appendChild(script);
    });

    return paypalPromise;
};

export const renderPayPalButton = () => {  // New function to render the button
    if (!buttonRendered) {
        loadPayPalSDK()
            .then(PayPal => {
                if (PayPal) {
                    PayPal.Donation.Button({
                        env: 'production',
                        hosted_button_id: '2ZQPH7JVFSJDG',
                        image: {
                            src: 'https://www.paypalobjects.com/en_GB/i/btn/btn_donate_LG.gif',
                            alt: 'Donate with PayPal button',
                            title: 'PayPal - The safer, easier way to pay online!',
                        }
                    }).render('#donate-button');
                    buttonRendered = true; // Track that the button has been rendered
                }
            })
            .catch(error => {
                console.error("Error loading PayPal SDK:", error);
            });
    }
};